import breakpoints from '../../../util/css/media';

export default {
    explainerContainer: {
        marginBottom: 80
    },
    servicesHeader: {
        color: 'rgb(61, 153, 145)',
        marginBottom: 20
    },
    section: {
        paddingTop: 50,
        paddingBottom: 50
    },
    sectionBottom: {
        paddingBottom: 50
    },
    sectionBorder: {
        borderBottom: '2px solid #DDD'
    },
    imageDiv: {
        padding: 10,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column'
    },
    image: {
        borderRadius: 5
    },
    optimusLogo: {
        height: 150,
        width: 150,
        position: "relative",
        margin: "auto"
    },
    textHeaderStyle: {
        margin: 0
    },
    imageTextDiv: {
        display: 'flex',
        flexDirection: 'column'
    },
    alignRight: {
        //Only for small screens
        ['@media (max-width: ' + breakpoints.medium + 'px)']: {
            padding: '5px 10px'
        },

        //Only for large screens
        ['@media (min-width: ' + breakpoints.medium + 'px)']: {
            paddingRight: 30
        }
    },
    alignLeft: {
        //Only for small screens
        ['@media (max-width: ' + breakpoints.medium + 'px)']: {
            padding: '5px 10px'
        },

        //Only for large screens
        ['@media (min-width: ' + breakpoints.medium + 'px)']: {
            paddingLeft: 30
        }
    },
    positionHeader: {
        //Only for large screens
        ['@media (min-width: ' + breakpoints.medium + 'px)']: {
            position: 'relative',
            top: '10%'
        }
    },
    positionText: {
        //Only for large screens
        ['@media (min-width: ' + breakpoints.medium + 'px)']: {
            position: 'relative',
            top: '15%'
        }
    },
    justify: {
        textAlign: 'justify'
    },
    explainerLink: {
        display: 'block',
        textDecoration: 'none',
        color: 'rgb(61, 153, 145)',
        fontWeight: 600,
        marginTop: 5
    }
}


// WEBPACK FOOTER //
// ./src/components/Explainer/2/Explainer2Style.js